import { createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL, ENDPOINTS } from "../../utils/topic-endpoints";

export const getCollectionData = createAsyncThunk(
  "collectionImages/getCollectionData",
  async (topic, { rejectWithValue }) => {
    const searchEndpoint = ENDPOINTS.filter((ep) => ep.title === topic).map(
      (endpoint) => endpoint.endpoint
    );
    const url = BASE_URL + searchEndpoint;
    const response = await fetch(url);
    if (!response.ok){
        return rejectWithValue("Couldn't find Collection")
    }
    const data = await response.json();
    return {
        collectionName: topic,
        collectionImages: data
    }
  }
);
